import { useFormContext, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ControlledRichTextEditor } from '@calendly/rich-text-editor'
import { forwardRef, useEffect } from 'react'

import ErrorMessage from '../../../core/error_message'
import { supportedFormattingForBody } from '../config'
import { FieldBlock, Label } from './styles'
import { useTextField } from '../hooks/use_text_field'

export const RichTextBodyField = forwardRef(({ errorMessage, ...props }, forwardedRef) => {
  const [{ name, value }] = useFormField(props)

  const fieldProps = useTextField(props)

  const { setFieldError } = useFormContext()

  useEffect(() => {
    setFieldError(name, '')
  }, [name, setFieldError, value])

  return (
    <FieldBlock data-component="body_field_block">
      <Label htmlFor="body">
        {I18n.t('publisher.workflows.actions.body')}
      </Label>
      <ControlledRichTextEditor
        {...fieldProps}
        ref={forwardedRef}
        id="body"
        hasError={Boolean(errorMessage)}
        supportedFormatting={supportedFormattingForBody}
      />
      <ErrorMessage
        message={errorMessage}
      />
    </FieldBlock>
  )
})
